import styled from "styled-components";


export const IssuesWrapper = styled.div`
.issuesList{
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-top:3%;
}


`;
